import { Component, OnInit,Input } from '@angular/core';
import { Client } from '../../interfaces/Client.interface';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart } from '@angular/router';
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [LoginService]
})
export class HomeComponent implements OnInit {

  public collapedSideBar: boolean;
  public infoUser: Client;
  public modal1:boolean;
  public modal2:boolean;

  @Input() infuser: Client;

  public dataActivatedRute:any;
  public pageNow:string;
  public pageLater:string;
  public objSession:any;

  constructor(
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    private _loginService: LoginService
  ) {

  }

  ngOnInit() {
    if(localStorage.getItem('infoClient')){
      this.infoUser=JSON.parse(localStorage.getItem('infoClient'));
    }
    this.checkSession();
  }

  public setAnalyticsValue(pageNow:string):void{
    if(!localStorage.getItem('pageLater')){
      localStorage.setItem('pageLater','Login');
      this.pageLater = 'Login';
      this.objSession = {
        'session_id': JSON.parse(localStorage.getItem('objsession')).id,
        'page_before': this.pageLater,
        'page_now': pageNow,
        'lang': sessionStorage.getItem('lang').toString()
      };
      this._loginService.sendStadistic(this.objSession).subscribe(
        () => {},
        error => {
          console.error('Error detection')
        }
      );
      localStorage.setItem('pageLater', pageNow);
    }else{
      this.pageNow = pageNow;
      this.pageLater = localStorage.getItem('pageLater');
      this.objSession = {
        'session_id': JSON.parse(localStorage.getItem('objsession')).id,
        'page_before': this.pageLater,
        'page_now': this.pageNow,
        'lang': sessionStorage.getItem('lang').toString()
      };
      this._loginService.sendStadistic(this.objSession).subscribe(
        () => {},
        error => {
          console.error('Error detection')
        }
      );
      localStorage.setItem('pageLater', this.pageNow);
    }

  }


  public refreshSessionIdInfo(value:any):void{
    sessionStorage.setItem('pageLater',value);
  }

  public receiveCollapsed($event) {
    this.collapedSideBar = $event;
  }

  public checkSession(){
    if(!localStorage.getItem('infoClient') || !localStorage.getItem('auth_data')){
      this._router.navigate(['/login']);
    }
  }

}
